import axios from 'axios';

import config from '../config'

import {
    ProjectResponse,
    ProjectsResponse,
    SaveOrUpdateModel,
    AuthenticationToken,
    SaveResult,
    ProjectCountResponse,
    SubcontractsTree, SubcontractRequest, SubcontractRequestResult, Subcontracts, SubcontractSaveResult,
} from '@/types/supplier-search'
import { PurchaseMethodTemplate, PurchaseMethodTemplateFilter } from '@/types/stock-settings'

import { OkatoModel, UnitsModel } from '@/types/common'

const instance = axios.create({
    baseURL: config.tenderWebApiUrl,
    timeout: 10000000,
    withCredentials: true,
    headers: { Pragma: 'no-cache' }
});

export class TenderWebApi {

    public static getProjects = () => instance.get<ProjectsResponse>('/SupplierFinder/GetProjects');

    public static saveProject = (data: SaveOrUpdateModel) => instance.post<SaveResult>('/SupplierFinder/Create', data);

    public static updateProject = (data: SaveOrUpdateModel) => instance.post<SaveResult>('/SupplierFinder/Edit', data);

    public static createCommercialOffersRequest = (data: SaveOrUpdateModel) => instance.post<SaveResult>('/ProposalRequest/Create', data);

    public static updateCommercialOffersRequest = (data: SaveOrUpdateModel) => instance.post<SaveResult>('/ProposalRequest/Edit', data);

    public static GetUnitsByKeyword = (keyword: string) => instance.get<UnitsModel[]>(`/SupplierFinder/GetUnitsByKeyword?keyword=${keyword}`);

    public static convertCharacteristic = (data: SaveOrUpdateModel) => instance.post('', data)

    public static getUserInfo = () => instance.get<AuthenticationToken>('/Organization/GetUserInfoWithOrganization');

    public static getProjectCount = () => instance.get<ProjectCountResponse>('/Trade/GetActiveProjectCount');

    public static getStockPurchaseMethodTemplates = (data: PurchaseMethodTemplateFilter) => instance.post<PurchaseMethodTemplate[]>('/PurchaseMethodTemplates/List', data);

    public static getRegionsKladrList = () => instance.get<OkatoModel[]>('/Dictionary/getRegionsKladrList');

    public static getProject = (id: number) => instance.get<ProjectResponse>(`/ProposalRequest/GetProject?id=${id}`);
}